import React, { useState, useEffect } from "react";
import OnlineBoard from "./OnlineBoard";

const OnlineGame = ({
  socket,
  name,
  roomId,
  friend,
  setFriend,
  players,
  setPlayers,
  gridSize
}) => {
  const [scores, setScores] = useState([0, 0]);
  const [isPaired, setIsPaired] = useState(false);

  useEffect(() => {
    if(players[1]==name){
      setIsPaired(true);
    }
    // Listen for incoming messages
    socket.on("receive_msg", (data) => {
      if (data.message[0]=="dot") {
        // console.log(data.message)
        setFriend(data.senderSocketId);
        setPlayers(data.message[1]);
        setIsPaired(true);
      }
    });

    return () => {
      socket.off("receive_msg");
    };
  }, []);


  return (
    <div className="flex flex-col items-center">
      <div className="border-theme-5 border-4 p-2 ">
        <h4 className="text-center text-theme-2 font-mono font-semibold">{`RoomID: ${roomId}`}</h4>
        <div className="flex min-w-[250px] mb-2 font-semibold font-serif text-lg px-4">
          {isPaired ? (
            players[0] === name ? (
              <div className="flex justify-between space-x-2 w-full">
                <h4 className="text-blue-600">{`You: ${scores[0]}`}</h4>
                <h4 className="text-red-500">{`${players[1]}: ${scores[1]}`}</h4>
              </div>
            ) : (
              <div className="flex justify-between space-x-2 w-full">
                <h4 className="text-blue-600">{`${players[0]}: ${scores[0]}`}</h4>
                <h4 className="text-red-500">{`You: ${scores[1]}`}</h4>
              </div>
            )
          ) : (
            <div></div>
          )}
        </div>
      </div>
      {isPaired?(<OnlineBoard socket={socket} gridsize={gridSize} players={players} scores={scores} setScores={setScores} name={name} roomId={roomId} friend={friend} />):(
        <div></div>
      )}
    </div>
  );
};

export default OnlineGame;
